// extracted by mini-css-extract-plugin
export default {"modalWrapper":"_3uKLMNSbY1kJg2mc2a_Mo","modalContainer":"Y6wUzyWhNy0coUl8v9CY_","modalButtons":"C4WspOBDBN9Dah37O-oAt","btn":"_3xXP_stHpQUyjtg_62gc8H"};